import React from "react";
import { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import joi from "joi";
import axios from "axios";
import api from "../config.json";
import swal from "sweetalert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Table from "../../src/Common/table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, } from "@fortawesome/free-solid-svg-icons";
import _, { has, startCase } from "lodash";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../utill/LoadingComponent";
import { DatePicker, Space, Tooltip } from "antd";
import { Select } from 'antd';
import moment from "moment";
import QRCodeScanner from "../Common/QRCodeScanner";
import HighSpeedDataType from "../Common/HighSpeedDataType";
import HighSpeedString from "../Common/HighSpeedString";

const schema = {
    PartNumber: joi.string().required().label("PartName"),
    MoldId: joi.string().required().label("MoldId"),
    RequestType: joi.string().required().label("RequestType"),
    Description: joi.string().required().label("Description"),
};

const QRCodeInspection = ({ config, DisplayTitle, ButtonRedirect, ChecksheetType, RightName, getRightsForAccess, Heading }) => {
    const ref = useRef(null);
    const ref1 = useRef(null);
    const history = useHistory();
    const [errors, seterrors] = useState("");
    const [startScann, setStartScann] = useState(false);
    const [querySuccess, setquery] = useState(false);
    const [datafromoutercomponent, setdatafromoutercomponent] = useState([]);
    const [inputData, setInputData] = useState({ DateTime: new Date() })
    const [qrCodeStr, setQrCodeStr] = useState("")
    const [templateList, setTemplateList] = useState([])
    const [InputData, setinputData] = useState([]);
    const [MoldList, setMoldList] = useState([]);
    const [types, setAllTypes] = useState([]);
    const [CurrentPage, setCurrentPage] = useState(1);
    const [TotalPage, setTotalPage] = useState(5);
    const [PageSize, setPageSize] = useState(25);
    const [Date1, setDate] = useState({ From: "2024/1/8", Till: new Date() });

    const [sortColumn, setSortColumn] = useState({
        path: "check_sheet_type",
        order: "asc",
    });

    const [DataForSpare, setDataForSpare] = useState({});

    const [SrStatus, setSrStatus] = useState("");
    const [parts, setAllParts] = useState([]);
    const [Item, setAllItem] = useState([]);
    const [Items, setAllItems] = useState([]);
    const [inspectionList, setInspectionList] = useState([])

    const [cameraType, setCameraType] = useState('Unknown');

    useEffect(() => {
        async function detectCamera() {
            try {
                // Get a list of all available media devices
                const devices = await navigator.mediaDevices.enumerateDevices();

                // Filter out video input devices (cameras)
                const videoDevices = devices.filter(device => device.kind === 'videoinput');

                videoDevices.forEach((device) => {
                    if (device.label.toLowerCase().includes('front')) {
                        setCameraType('Front Camera');
                    } else if (device.label.toLowerCase().includes('back')) {
                        setCameraType('Back Camera');
                    }
                });

                // Optionally, you can choose to use facingMode as well
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                const track = stream.getVideoTracks()[0];
                const capabilities = track.getCapabilities();
                if (capabilities.facingMode) {
                    setCameraType(capabilities.facingMode.includes('user') ? 'Front Camera' : 'Back Camera');
                }

            } catch (error) {
                console.error('Error detecting camera: ', error);
            }
        }

        detectCamera();
    }, []);


    const { RangePicker } = DatePicker;
    console.log(DataForSpare, "testing")
    useEffect(() => {
        setquery(true)
        axios
            .get(api.api + "customInspection")
            .then((result) => {
                setquery(false)
                setInspectionList(result.data);
            })
            .catch((err) => {
                setquery(false)
                console.log(err);
            })
    }, [])


    const handleOnChange = (name, value) => {
        const obj = { ...inputData }
        obj[name] = value;
        let all;
        if (name === 'Customer') {
            all = Item.filter(item => value === item.CustomerName);
            // all = Item.filter(item=>item.CustomerName === value[0])
            const result = all.map(item => {
                return {
                    label: item.ItemName,  // Override or add the label property
                    value: item.ItemName,  // Override or add the value property
                    ...item,  // Spread the original properties first
                };
            });
            const unique = [];
            const names = new Set();

            for (const item of result) {
                if (!names.has(item.ItemName)) {
                    names.add(item.ItemName);
                    unique.push(item);
                }
            }
            console.log(name, "vfdhvbdv", value, inputData, result, all, Item,)

            setAllTypes(unique)

        } else if (name === 'ItemName') {
            all = types.filter(item => value === item.ItemName);
            // all = types.filter(item=>item.ItemName=== value[0])
            const result = all.map(item => {
                return {
                    ...item,  // Spread the original properties first
                    label: item.ItemNumber,  // Override or add the label property
                    value: item.ItemNumber   // Override or add the value property
                };
            });
            const unique = [];
            const names = new Set();

            for (const item of result) {
                if (!names.has(item.ItemNumber)) {
                    names.add(item.ItemNumber);
                    unique.push(item);
                }
            }
            setAllItems(unique)


        } else if (name === 'ItemNumber') {
            // all =  Items.filter(item => value.some(one => one === item.ItemNumber));

            all = Items.filter(item => item.ItemNumber === value)

            console.log(all, "vsfouvhsdvl")
        }
        setInputData(obj);
        console.log(obj);
    }
    useEffect(() => {
        getAllDropDownData();

    }, [DisplayTitle])

    useEffect(() => {
        Heading(DisplayTitle)
        setInputData({ DateTime: new Date() })
    }, [DisplayTitle])


    const getOperations = () => {
        const inputObj = { ...inputData }
        const items = [...Item]
        let operations = items.filter(x => inputObj.ItemName == x.ItemName && inputObj.ItemNumber == x.ItemNumber)
        operations = operations.map(x => { return { label: x.Operation, value: x.Operation } })
        operations = _.uniqBy(operations, 'value')
        return operations
    }



    const getAllDropDownData = () => {
        axios.get(api.api + "item")
            .then((result) => {
                result.data = result.data.filter(x => {
                    const isHaveCheckSheet = x.Inspection.find(check => check.InspectionName == ChecksheetType && check.Enable)
                    if (isHaveCheckSheet && isHaveCheckSheet.checkSheetTitle) {
                        return x
                    }
                })
                const all = result.data.map((item) => ({
                    label: item.CustomerName,
                    value: item.CustomerName,
                    ...item
                }));

                const unique = [];
                const names = new Set();

                for (const item of all) {
                    if (!names.has(item.CustomerName)) {
                        names.add(item.CustomerName);
                        unique.push(item);
                    }
                }
                console.log(result.data, "wsivbfisd", all, unique)
                setAllItem(result.data)
                setAllParts(unique)
                setAllTypes([])
                setAllItems([])

            })
            .catch((err) => {
                console.log(err, "Error")
            })


    }



    const columns = [
        { path: "DateTime", label: "Date", content: (obj) => <React.Fragment><label>{moment(obj.DateTime).format('DD-MM-YY ')}</label><br /></React.Fragment> },
        { path: "Item", label: "Item Name" },
        { path: "InspectionType", label: "Inspection Type" },
        { path: "OkParts", label: "Ok Parts" },
        { path: "QtyToInspect", label: "Qty to Inspect" },
        { path: "QtyInspected", label: "Qty Inspected" },



        // { path: "check_sheet_title", label: "Check Sheet Title",  content: (obj) => (
        //   <React.Fragment>
        //     {console.log(obj,"crfbcrfbcrbhrfc")}
        // {obj.check_sheet_title.map(item=>item.Title).join(' , ')}
        //   </React.Fragment>
        // ), },
        // // { path: 'Description', label: 'Description'},
        // {
        //   path: "StateName",
        //   label: "Current State",
        //   content: (obj) => (
        //     <React.Fragment>
        //       <button
        //         style={{
        //           border:
        //             obj.StateName !== "Close"
        //               ? "1px solid #86d486"
        //               : "1px solid #ff9393",
        //           color: obj.StateName !== "Close" ? "green" : "red",
        //           background: obj.StateName !== "Close" ? "#def1de" : "#fee5e5",
        //           fontSize: "14px",
        //         }}
        //         className="rounded-4 m-0 px-2 py-1"
        //       >
        //         {obj.StateName}
        //       </button>
        //     </React.Fragment>
        //   ),
        // },

        // {
        //   key: "createdAt",
        //   label: "Created Date",
        //   content: (obj) => (
        //     <React.Fragment>
        //       <label>{obj.createdAt.split("T")[0]}</label>

        //       <br />
        //     </React.Fragment>
        //   ),
        // },

        // {
        //   key: "updatedAt",
        //   label: "Last Updated Date",
        //   content: (obj) => (
        //     <React.Fragment>
        //       <label>{obj.createdAt.split("T")[0]}</label>

        //       <br />
        //     </React.Fragment>
        //   ),
        // },
        // {
        //   key: "add",
        //   content: (obj) => (
        //     <React.Fragment>
        //       {obj.StateName !== "Close" ? (
        //     <Tooltip placement="top" title={'Update state'}>


        //           <Link
        //             to={{
        //               pathname: ButtonRedirect,
        //               state: { data: obj.LUID, obj: obj }, // Pass the data as state
        //             }}
        //           ><button
        //           onClick={() => console.log(obj, "cdsiyvcsu ")}
        //           type="button"
        //           style={{ border: "none" }}
        //           disabled={obj.StateName === "Close" ? true : false}
        //           className="btn "
        //         >
        //             <FontAwesomeIcon color="#007bff" icon={faEdit} />
        //         </button>
        //           </Link>
        //         </Tooltip>

        //       ) : null}
        //     </React.Fragment>

        //   ),
        // },


    ];

    useEffect(() => {
        setquery(true);

        axios
            .get(api.api + "checkSheetDataEntry",
                //    {
                //   PageSize: PageSize,
                //   Page: CurrentPage,
                //   From: Date1.From,
                //   Till: Date1.Till,
                // }
            )
            .then((result) => {
                if (result.status == 200) {
                    const filter = result.data.filter(item => item.InspectionType == ChecksheetType)
                    console.log(result.data, "fdvduhhivfb", filter);
                    // setTotalPage(Math.ceil(result.data.count / PageSize) * 10);
                    setinputData(filter);
                    setquery(false);
                }
            })
            .catch((err) => {
                toast.success(`${err}`, {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        backgroundColor: "red",
                        color: "white",
                    },
                });
                setquery(false);
            });

        setSrStatus("Created");
    }, [CurrentPage, ChecksheetType,PageSize]);



    const handleSort = (sortColumn) => {
        if (InputData.length > 0) {
            const sorted = _.orderBy(
                InputData,
                [sortColumn.path],
                [sortColumn.order]
            );
            setSortColumn(sortColumn);
            setInputData(sorted);
        }
    };

    console.log(datafromoutercomponent, "isdbvibf");
    const returnValue = (data, type, Name) => {
        const keys = Object.keys(data); // Extract keys from the data object
        const values = Object.values(data); // Extract values from the data object
        // Create a new object with the existing data from outer component
        // and add/update the new key-value pair
        console.log(keys, values, "input filed values ");
        if (keys[0] === "PartNumber") {
            SendPartNumber(values[0]);
        }
        const newData = {
            ...datafromoutercomponent,
            [keys[0]]: values[0], // Assuming there's only one key-value pair in the data object
        };

        // Update the outer component data
        setdatafromoutercomponent(newData);

        return newData;
    };
    const SendPartNumber = (partnumber) => {
        setquery(true);

        axios
            .put(api.api + "getMouldIDs", { id: partnumber })
            .then((result) => {
                if (result.status == 200) {
                    console.log(result.data, "Mould Id Request");
                    setMoldList(result.data);
                    setquery(false);
                } else {
                    swal("Unable to submit data");
                    setquery(false);
                }
            })
            .catch((err) => {
                toast.success(`${err}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        backgroundColor: "green",
                        color: "white",
                    },
                });
                setquery(false);

                swal(`${err}`);
            });
    };



    // Function to handle changes in the input field

    const SelectedDates = (dates) => {
        console.log("Selected dates", dates);
        if (dates) {
            setDate({
                From: dates[0].format("YYYY-MM-DD"),
                Till: dates[1].format("YYYY-MM-DD"),
            });
        }
    };
    const handelGetSR = () => {
        setquery(true);

        axios
            .put(api.api + "MouldUnloadingDataEntry", {
                PageSize: PageSize,
                Page: CurrentPage,
                From: Date1.From,
                Till: Date1.Till,
            })
            .then((result) => {
                if (result.status == 200) {
                    console.log(
                        {
                            PageSize: PageSize,
                            Page: CurrentPage,
                            From: Date1.From,
                            Till: Date1.Till,
                        },
                        "fdgdfvdfvfvduhhivfb",
                        result.data
                    );
                    setTotalPage(Math.ceil(result.data.count / PageSize) * 10);
                    setInputData(result.data.data);
                    setquery(false);
                }
            })
            .catch((err) => {
                toast.success(`${err}`, {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        backgroundColor: "red",
                        color: "white",
                    },
                });
                setquery(false);

                swal(`${err}`);
            });
    };

    useEffect(()=>{
     if(qrCodeStr.length==16){
        handelRedirect(qrCodeStr)
     }
    },[qrCodeStr])
    const handelRedirect = (string) => {
        const inputObj = { ...inputData }
        const oneItem = Item.find(Item => Item.Inspection.some(x => x.QRCodeId == string));
        if (oneItem) {
            inputObj.Customer=oneItem.CustomerName
            inputObj.ItemName=oneItem.ItemName
            inputObj.ItemNumber=oneItem.ItemNumber
            inputObj.Operation=oneItem.Operation
        }
        if (inputObj.Customer && inputObj.ItemName && inputObj.ItemNumber) {
            const filteredItems = Item.filter(Item => Item.ItemName === inputObj.ItemName && Item.ItemNumber === inputObj.ItemNumber && Item.Operation === inputObj.Operation);
            if (filteredItems.length > 0) {
                if (filteredItems[0]) {
                    const inspection = filteredItems[0].Inspection.find(x => x.InspectionName == ChecksheetType)
                    const config1 = inspectionList.find((x) => x._id == config._id)
                    if (config1 && config1.ContinousDataEntry == "enable" && inspection.NumOfSamples > 1) {
                        swal({
                            title: "Are you sure?",
                            text: "You want be to submit data entry for this inspection in continuous mode because the sample size is not greater than one.",
                            icon: "warning",
                            buttons: {
                                cancel: {
                                    text: "Cancel",
                                    value: null,
                                    visible: true,
                                    className: "btn-secondary",
                                    closeModal: true,
                                },
                                confirm: {
                                    text: "Proceed",
                                    value: true,
                                    visible: true,
                                    className: "btn-danger",
                                    closeModal: true
                                }
                            }
                        }).then((willDelete) => {
                            if (willDelete) {
                                // Action for the confirm button
                                history.push(ButtonRedirect, { config: config, obj: inputObj, item: filteredItems[0], ChecksheetType: ChecksheetType });
                            } else {
                            }
                        });

                    } else {
                        history.push(ButtonRedirect, { config: config, obj: inputObj, item: filteredItems[0], ChecksheetType: ChecksheetType });
                    }
                }


            } else {
                swal('No items found with the specified ItemNumber');
            }
        } else {
            swal('No Item Exist On This Code');
        }
    };

    return (
        <div>
            {querySuccess ? <Loading /> : ""}

            {/* <div className="text-center heading-bg mb-4">
        <h4 className="text-white p-0 m-0">{DisplayTitle}</h4>
      </div> */}

            <ToastContainer />
            <div className="row ">

                {/* <div className="col-sm-2 my-4">
          <button
            className="btn-sm btn-primary  shadow "
            style={{ marginTop: '29px' }}
            onClick={() => handelRedirect()}
          >
            Start {DisplayTitle}
          </button>
        </div> */}
                <div className="col-sm-12 my-2 text-center">
                    {cameraType == "Front Camera" ? <HighSpeedString value={qrCodeStr} field={{ FieldName: "Scan Item Code" }} getString={(string) => {
                        if (string){
                          setQrCodeStr(string)
                        }
                          //  handelRedirect(string)
                    }} /> :
                        <button
                            className="btn-sm btn-primary  shadow "
                            style={{ marginTop: '29px' }}
                            onClick={() => setStartScann(true)}
                        >
                            Scan QR Code
                        </button>}
                </div>
            </div>
            {startScann && <QRCodeScanner isScann={startScann} setScanning={setStartScann} getQRCodeString={(string) => {
                if (string) {
                    setQrCodeStr(string)
                }
            }} />}
            {/* <div className="d-flex mx-2">
        <div className="col-sm-3">
          <div className="form-group text-center d-flex flex-column">
            <label className="small">From - Till</label>
            <div className="">
              <Space direction="vertical" size={12}>
                <RangePicker onChange={SelectedDates} />
              </Space>
            </div>
          </div>
        </div>
        <div className="mx-2 my-4">
          <button
            className="btn btn-primary rounded-4 shadow"
            onClick={() => handelGetSR()}
          >
            Apply
          </button>
        </div>
        <div className="mx-2 my-4">
          <button
            className="btn btn-primary rounded-4 shadow"
            onClick={() => history.push(ButtonRedirect)}
          >
            Start {DisplayTitle}
          </button>
        </div>
      </div> */}

            <div className="p-2 mx-2 rounded-4 shadow">
                {InputData && InputData.length > 0 ? (
                    <Table
                        id="moldHistory"
                        onSort={handleSort}
                        columns={columns}
                        sortColumn={sortColumn}
                        data={InputData}
                    />
                ) : (
                    <Table
                        id="mould-raw-material"
                        onSort={handleSort}
                        columns={columns}
                        sortColumn={sortColumn}
                        data={InputData}
                    ></Table>
                )}
            </div>
        </div>
    );
};

export default QRCodeInspection;
